import {
  RootFactory,
  ServicesFactory,
  TestimonialsFactory,
  ContactFactory,
  PortfolioFactory,
  PortfolioFiltersFactory,
} from '../factories';

export const baseBuilder = () => {
  return {
    buildTemplate: (website) => ({
      theme: "base",
      ...RootFactory.getBase(website),
      services: ServicesFactory.getBase(website),
      testimonials: TestimonialsFactory.getBase(website),
      contact: ContactFactory.getBase(website),
      portfolio: PortfolioFactory.getBase(website),
      portfolioFilters: PortfolioFiltersFactory.getBase(website),
    })
  };
};



// WEBPACK FOOTER //
// ./src/store/generators/websiteTemplates/builders/BaseBuilder.js